import { useState, useEffect } from 'react';
import { getUserRole } from '../service/storage.service';

export const useUserRole = () => {
  const [userRole, setUserRole] = useState<string | null>(null);
  
  useEffect(() => {
    // Obtener el rol del usuario
    const role = getUserRole();
    setUserRole(role);
  }, []);

  // Función para verificar si el usuario tiene un rol específico
  const hasRole = (requiredRoles: string | string[]): boolean => {
    if (!userRole) return false;
    
    if (typeof requiredRoles === 'string') {
      return userRole === requiredRoles;
    }
    
    return requiredRoles.includes(userRole);
  };

  return {
    userRole,
    hasRole
  };
}; 